import { AccountType } from "@cosine/lib/api-models";

// 0 - 100K in increments of:
// $500 from 0 - 10K
// $1,000 from 10K - 100K
const checkingAndSavingsValues: Array<number> = [];
for (let i = 0; i <= 100_000_00;) {
  checkingAndSavingsValues.push(i);
  i += i < 10_000_00 ? 500_00 : 1_000_00;
}

// 0 – 100K in increments of 1,000
const creditCardValues = Array.from({
  length: 100000_00 / 1000_00 + 1,
}, (_, i) => i * 1000_00);

// 0 – 1M in increments of 5,000
const investmentAndRetirementValues = Array.from({
  length: 1000000_00 / 5000_00 + 1,
}, (_, i) => i * 5000_00);

// 0 - 500K in increments of:
// $1,000 from 0 - 10K
// $10,000 from 10K - 500K
const studentLoanValues: Array<number> = [];
for (let i = 0; i <= 500_000_00;) {
  studentLoanValues.push(i);
  i += i < 10_000_00 ? 1000_00 : 10_000_00;
}

// 0 - 5M in increments of:
// $1,000 from 0 - 10K
// $10,000 from 10K - 1M
// $100,000 from 1M - 5M
const mortgageValues: Array<number> = [];
for (let i = 0; i <= 5_000_000_00; ) {
  if (i < 10_000_00) {
    mortgageValues.push(i);
    i += 1000_00;
  } else if (i < 1_000_000_00) {
    mortgageValues.push(i);
    i += 10_000_00;
  } else {
    mortgageValues.push(i);
    i += 100_000_00;
  }
}

export default function (accountType: keyof typeof AccountType) {
  switch (accountType) {
    case AccountType.Checking:
    case AccountType.Savings:
      return [...checkingAndSavingsValues];
    case AccountType.CreditCard:
      return [...creditCardValues];
    case AccountType.Investment:
      return [...investmentAndRetirementValues];
    case AccountType.Mortgage:
      return [...mortgageValues];
    case AccountType.StudentLoan:
      return [...studentLoanValues];
    default:
      return [];
  }
}
